import styles from './ProgressBar.module.scss';
import React from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useSearchParams } from 'react-router-dom';
import { nbItemsPerPage } from '../../configs';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../constants/searchParamKeys';
export const ProgressBar = () => {
    const { nbHits } = useAlgoliaDataContext();
    const [searchParams] = useSearchParams();
    if (nbHits < 1)
        return null;
    const page = +(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1);
    const viewedItems = Math.min(nbItemsPerPage * page, nbHits);
    return (React.createElement("div", { className: `text:center ${styles.container}` },
        React.createElement("p", { className: `m:0 ${styles.text}` },
            "You've viewed ",
            viewedItems,
            " of ",
            nbHits,
            " wall art prints"),
        React.createElement("div", { className: styles.bar, style: { '--slider-width': `${viewedItems / nbHits * 100}%` } })));
};
